import authority from './config.authority';
import { routes } from './config.routeName';

export interface RouteMeta {
  id: string;
  label: string;
  path: string;
  public: boolean;
  showInMenu?: boolean;
  authority: string[];
}

const routeMeta: RouteMeta[] = [
  {
    id: 'route-01',
    label: 'Home',
    path: routes.HOME,
    public: true,
    showInMenu: true,
    authority: authority.Home,
  },
  {
    id: 'route-02',
    label: 'Ontology',
    path: routes.ONTOLOGY,
    public: true,
    showInMenu: true,
    authority: authority.Ontology,
  },
  {
    id: 'route-03',
    label: 'JsonTool',
    path: routes.JSON,
    public: true,
    showInMenu: false,
    authority: authority.Json,
  },
  {
    id: 'route-04',
    label: 'MarkdownTool',
    path: routes.MARKDOWN,
    public: true,
    showInMenu: true,
    authority: authority.Markdown,
  },
  {
    id: 'route-07',
    label: 'SparqlViewer',
    path: routes.SPARQL,
    public: true,
    showInMenu: true,
    authority: authority.Sparql,
  },
  {
    id: 'route-06',
    label: 'CryptoTool',
    path: routes.CRYPTO,
    public: true,
    showInMenu: true,
    authority: authority.Crypto,
  },
  {
    id: 'route-05',
    label: 'Authority',
    path: routes.AUTHORITY,
    public: true,
    showInMenu: true,
    authority: authority.Authority,
  },
];

export default routeMeta;
